var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 79,
    viewBox: "0 0 88 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5332,
    cy: 48.8443,
    r: 7,
    transform: "rotate(-4.75923 13.5332 48.8443)",
    fill: "#AF09D8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.3601,
    cy: 8.48493,
    r: 7,
    transform: "rotate(-4.75923 64.3601 8.48493)",
    fill: "#AF09D8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6048,
    cy: 18.9051,
    r: 10.5,
    transform: "rotate(-4.75923 29.6048 18.9051)",
    fill: "#AF09D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02004 48.2008L43.6764 41.7498L37.9858 68.5735L8.02004 48.2008Z",
    fill: "#AF09D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9019 3.63699L78.4589 37.8151L48.3609 36.475L64.9019 3.63699Z",
    fill: "#AF09D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3051 21.0437L71.8988 30.2899L34.5799 62.5481L31.3051 21.0437Z",
    fill: "#AF09D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3256 63.2539L74.5319 28.6909L81.5319 43.6909C65.0323 52.2947 56.4366 58.0199 44.592 73.2761L30.3256 63.2539Z",
    fill: "#AF09D8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.0964,
    cy: 42.098,
    r: 7.5,
    transform: "rotate(-4.75923 50.0964 42.098)",
    fill: "#FFE143"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.4378,
    cy: 33.482,
    r: 5,
    transform: "rotate(-4.75923 65.4378 33.482)",
    fill: "#FFE143"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.204,
    cy: 55.9859,
    r: 5,
    transform: "rotate(-4.75923 36.204 55.9859)",
    fill: "#FFE143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownIcon);
export default __webpack_public_path__ + "static/media/crownIcon.f625ccf8e9b88693211b5bc19f5577ae.svg";
export { ForwardRef as ReactComponent };